// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"c0bb7407","453":"fa7fb07f","699":"fa75a822"}[chunkId] + ".chunk.js";
};